define('views/search/types',[
  "backbone",
  "ext/bootstrap/dropselect"
], function (Backbone) {
  "use strict";

  return Backbone.View.extend({
    events: {
      "click a": "update",
    },

    initialize: function () {
      this.model.on("change", function (model) {
        if (!model.has("type")) {
          this.$el.trigger("dropselect:reset");
        }
      }, this);

      return this.render();
    },

    render: function () {
      this.$el.dropselect();
      return this;
    },

    getSelectedValues: function () {
      return this.$el.find(".active").map(function () {
        return $(this).data("type");
      }).get();
    },

    update: function (e) {
      var types = this.getSelectedValues();

      e.preventDefault();

      types.length ?
        this.model.set("type", types) :
        this.model.unset("type");

      return this;
    }
  });
});

